import { render, staticRenderFns } from "./checkResultdetails.vue?vue&type=template&id=b42eed34&scoped=true&"
import script from "./checkResultdetails.vue?vue&type=script&lang=js&"
export * from "./checkResultdetails.vue?vue&type=script&lang=js&"
import style0 from "./checkResultdetails.vue?vue&type=style&index=0&id=b42eed34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b42eed34",
  null
  
)

export default component.exports